import React, {useEffect, useState} from 'react';
import styles from './Content.module.scss'
import HomeContent from "../HomeContent/HomeContent";
import {Route, Switch} from "react-router-dom";
import Scills from "../Skills/Skills";
import Contacts from "../Contacts/Contacts";
import Portfolio from "../Portfolio/Portfolio";
import Redirect from "react-router-dom/es/Redirect";

import Img from './react.png'


const Content = (props) => {

    return (

        <div className={styles.content} >
            <Switch>
                <Route path="/" exact component={HomeContent}/>
                <Route path='/mi_info'/>
                <Route path='/skills' exact component={Scills}/>
                <Route path='/contacts' exact render={() => <Contacts/>}/>
                <Route path='/portfolio' exact render={() => <Portfolio/>}/>
                <Route component={HomeContent}/>
            </Switch>
        </div>


    )
};

export default Content;